import { render, staticRenderFns } from "./UiProgress.vue?vue&type=template&id=5746238c&"
import script from "./UiProgress.vue?vue&type=script&lang=js&"
export * from "./UiProgress.vue?vue&type=script&lang=js&"
import style0 from "./UiProgress.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports